/** Compute pixel position + scale for an overlay given anchor/size */
export function computeOverlayPlacement(
  anchor: string,
  sizeFactor: number,
  canvasW: number,
  canvasH: number,
  imgW: number,
  imgH: number,
): { x: number; y: number; scale: number } {
  const shortSide = Math.min(canvasW, canvasH);
  const targetW = shortSide * sizeFactor;
  const scale = targetW / imgW;
  const overlayW = imgW * scale;
  const overlayH = imgH * scale;

  const pad = shortSide * 0.03; // 3% padding from edges

  let x = 0;
  let y = 0;

  // Horizontal
  if (anchor.includes('left')) x = pad;
  else if (anchor.includes('right')) x = canvasW - overlayW - pad;
  else x = (canvasW - overlayW) / 2; // center

  // Vertical
  if (anchor.includes('top')) y = pad;
  else if (anchor.includes('bottom')) y = canvasH - overlayH - pad;
  else y = (canvasH - overlayH) / 2; // middle

  return { x, y, scale };
}
